<template>
  <van-popup
    v-model="currentVisible"
    class="ln-dialog-wrapper"
    @closed="closed"
    close-on-click-overlay
    :lazy-render="false"
    :transition-appear="true"
    v-bind="attrs"
  >
    <div class="ln-dialog">
      <div v-if="attrs.title" class="ln-dialog-header">
        <span class="title">
          {{ attrs.title }}
        </span>
        <ImageButton
          class="close-icon"
          :src="require('@/assets/imgs/pay/x@2x.png')"
          @click.native="onCancel"
        ></ImageButton>
      </div>
      <div class="ln-dialog-body">
        <slot></slot>
      </div>
      <div class="ln-dialog-footer">
        <LnButton v-if="showCancelButton" @click.native="() => onCancel()" size="mini">{{
          $t('common.cancel')
        }}</LnButton>
        <LnButton v-if="showConfirmButton" type="primary" @click.native="() => onOk()" size="mini">{{
          $t('common.confirm')
        }}</LnButton>
      </div>
    </div>
  </van-popup>
</template>

<script>
import { ref, useAttrs, watch } from '@vue/composition-api';
import LnButton from '../../components/LnButton.vue';
import ImageButton from '../../components/ImageButton.vue';

export default {
  inheritAttrs: false,
  props: {
    visible: Boolean,
    onOk: Function,
    onCancel: Function,
    closed: Function,
    showCancelButton: {
      type: Boolean,
      default: false
    },
    showConfirmButton: {
      type: Boolean,
      default: false
    },
  },
  components: {
    LnButton,
    ImageButton
  },
  setup(props, { slots }) {
    const attrs = useAttrs();
    const currentVisible = ref(props.visible);

    watch(
      () => props.visible,
      val => {
        currentVisible.value = val;
      }
    );
    watch(
      () => currentVisible,
      val => {
        if (!val) {
          // 通过close图标关闭时，也会触发onCancel
          props.onCancel();
        }
      }
    );
    return {
      currentVisible,
      attrs
    };
  }
};
</script>

<style lang="scss">
// rem改成px，兼容PC
.ln-dialog-wrapper {
  width: 100%;
  display: flex;
  justify-content: center;
  background-color: transparent;
}
.ln-dialog {
  border-radius: 16px 16px 0 0;
  max-width: 720px;
  background-color: #fff;
  overflow: auto;
}
.ln-dialog-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 20px;
  .title {
    display: flex;
    justify-content: center;
    font-family: HYQiHei;
    font-weight: normal;
    color: #000000;
    font-size: 21px;
    font-weight: bold;
    flex: 1;
  }
  .close-icon {
    width: 17px;
  }
}
.ln-dialog-body {
  padding: 0 32px 0;
  font-size: 16px;
  overflow: auto;
}
.ln-dialog-footer {
  display: flex;
  justify-content: center;
  padding: 32px;
  .ln-button {
    padding: 12px 24px;
    border-radius: 6px;
    font-size: 18px;
    + .ln-button {
      margin-left: 16px;
    }
  }
}
</style>
